export default "__VITE_ASSET__BT$Z$0bj__"